/* Scart - Cards collection cliquables
   Dawn natif ne wrap que le h3 title en <a> dans card-collection.liquid.
   On rend toute la card cliquable via un click handler sur .collection-card-wrapper,
   sans toucher au CSS (un fix CSS via overlay ::before cassait le layout Dawn
   aspect-ratio --ratio-percent en sortant l'image de son slot reserved).
*/
(function () {
  function setup() {
    var wraps = document.querySelectorAll('.collection-card-wrapper, .card-wrapper.collection-card-wrapper');
    wraps.forEach(function (wrap) {
      if (wrap.dataset.scartClickable === '1') return;
      var link = wrap.querySelector('.card__heading a[href]');
      if (!link || !link.href) return;
      wrap.dataset.scartClickable = '1';
      wrap.style.cursor = 'pointer';
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('a, button, input, label, [role="button"]')) return;
        if (window.getSelection && window.getSelection().toString().length > 0) return;
        window.location.href = link.href;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
